import script from "./InboundNotifyRecipients.vue?vue&type=script&setup=true&lang=js"
export * from "./InboundNotifyRecipients.vue?vue&type=script&setup=true&lang=js"

import "./InboundNotifyRecipients.vue?vue&type=style&index=0&id=31b71435&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b71435"]])

export default __exports__